@if (open) {
<div class="home-enviar-modal" role="dialog" aria-modal="true" aria-labelledby="home-enviar-title"
  (click)="onBackdrop($event)">
  <div class="home-enviar-modal__panel" (click)="$event.stopPropagation()">
    <header class="home-enviar-modal__header">
      <span class="home-enviar-modal__header-spacer" aria-hidden="true"></span>
      <h2 class="home-enviar-modal__title" id="home-enviar-title">
        {{ copy.titulo }}
      </h2>
      <button type="button" class="home-enviar-modal__close" aria-label="Cerrar" [disabled]="enviando"
        (click)="onClose()">
        <span class="material-icons" aria-hidden="true">close</span>
      </button>
    </header>

    <div class="home-enviar-modal__body">
      @if (mensaje) {
      <p class="home-enviar-modal__text">{{ mensaje }}</p>
      }

      <div class="home-enviar-modal__actions">
        <button type="button" class="home-enviar-modal__btn home-enviar-modal__btn--secondary"
          id="btn-home-enviar-revisar" [disabled]="enviando" (click)="onRevisar()">
          {{ copy.ctaRevisar }}
        </button>
        <button type="button" class="home-enviar-modal__btn home-enviar-modal__btn--primary"
          id="btn-home-enviar-solicitud" [disabled]="enviando" (click)="onEnviar()">
          {{ enviando ? copy.ctaEnviando : copy.ctaEnviar }}
        </button>
      </div>
    </div>
  </div>
</div>
}
